import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import axios from "axios";
import HorizontalScroll from "../../components/horizontalScroll/horizontalScroll";
import "./kapelle.scss";

const Kapelle = () => {

    const [geschichte, setGeschichte] = useState([]);
    const [mitgliederAnzahl, setMitgliederAnzahl] = useState("");
    const [maennlichAnzahl, setMaennlichAnzahl] = useState("");
    const [weiblichAnzahl, setWeiblichAnzahl] = useState("");
    const [mitgliederDurchschnittsalter, setMitgliederDurchschnittsalter] = useState("");
    const [mitgliedAlt, setMitgliedAlt] = useState("");
    const [mitgliedJung, setMitgliedJung] = useState("");
    const [isLoading, setLoading] = useState(true);

    useEffect(() => {

        const fetchData = async () => {
            try {

                // Fetch für Geschichte
                const geschichteRes = await axios.get(`https://mk-lorenzen.it/admin/wp-json/wp/v2/geschichte?per_page=100&orderby=title&order=asc`);
                if (geschichteRes.data && geschichteRes.data.length > 0) {
                    setGeschichte(geschichteRes.data);
                }

                // Fetch für Mitglieder
                const mitgliederRes = await axios.get(`https://mk-lorenzen.it/admin/wp-json/wp/v2/mitglieder?per_page=100`);
                const mitglieder = mitgliederRes.data;
                const maennlichCount = mitglieder.filter(mitglied => mitglied.acf.geschlecht === "Männlich").length;
                const weiblichCount = mitglieder.filter(mitglied => mitglied.acf.geschlecht === "Weiblich").length;

                // Durchschnittsalter, älteste und jüngste Mitglieder berechnen
                const currentYear = new Date().getFullYear();
                let oldestAge = 0;
                let youngestAge = Infinity;
                const ages = mitglieder.map(mitglied => {
                    if (mitglied.acf.geburtsdatum) {
                        const birthYear = new Date(mitglied.acf.geburtsdatum).getFullYear();
                        const age = currentYear - birthYear;

                        // Bestimme das älteste und jüngste Alter
                        if (age > oldestAge) oldestAge = age;
                        if (age < youngestAge) youngestAge = age;

                        return age;
                    }
                    return 0;
                });

                const averageAge = ages.reduce((sum, age) => sum + age, 0) / ages.length;

                setMitgliederAnzahl(mitgliederRes.data.length);
                setMaennlichAnzahl(maennlichCount);
                setWeiblichAnzahl(weiblichCount);
                setMitgliederDurchschnittsalter(averageAge.toFixed(0));
                setMitgliedAlt(oldestAge);
                setMitgliedJung(youngestAge);

                setLoading(false);
            } catch (err) {
                console.error(err);
            }
        };

        fetchData();
    }, []);

    return (
        <div className="kapelle">
            <Helmet>
                <title>Kapelle | Musikkapelle St. Lorenzen</title>
            </Helmet>
            <motion.div
                className="header"
                initial={{ opacity: 0, y: 100 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, ease: "easeOut" }}
            >
                <h1>Kapelle</h1>
                <p>Die Musikkapelle St.Lorenzen besteht seit 1818 und ist somit die älteste Kapelle des Pustertals.<br />
                    Die organisatorischen Geschicke der Musikkapelle St. Lorenzen leitet seit dem Jahr 2025 Obmann Alexander Niederegger. Die musikalische Leitung obliegt seit dem Jahr 2019 Jakob Augschöll aus Luttach.
                </p>
            </motion.div>
            <div className="container">
                <div className="grid">
                    <motion.img
                        src="https://mk-lorenzen.it/admin/wp-content/uploads/2024/11/MKSTL-Final_Edit-scaled.jpg"
                        alt="Kapelle"
                        className="left"
                        initial={{ opacity: 0, y: 100 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5, ease: "easeOut" }}
                    />
                    <motion.div
                        className="right"
                        initial={{ opacity: 0, y: 200 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5, ease: "easeOut" }}
                    >
                        <h2>
                            <motion.span>{mitgliederAnzahl}</motion.span>
                            Mitglieder
                        </h2>
                        <div className="statistic">
                            <div className="item">
                                <span className="desc">Durchschnittsalter</span>
                                <motion.h2 className="value">{mitgliederDurchschnittsalter} Jahre</motion.h2>
                            </div>
                            <div className="item">
                                <span className="desc">Jüngstes Mitglied</span>
                                <motion.h2 className="value">{mitgliedJung} Jahre</motion.h2>
                            </div>
                            <div className="item">
                                <span className="desc">Ältestes Mitglied</span>
                                <motion.h2 className="value">{mitgliedAlt} Jahre</motion.h2>
                            </div>
                            <div className="item">
                                <span className="desc">Anzahl Frauen</span>
                                <motion.h2 className="value">{weiblichAnzahl}</motion.h2>
                            </div>
                            <div className="item">
                                <span className="desc">Anzahl Männer</span>
                                <motion.h2 className="value">{maennlichAnzahl}</motion.h2>
                            </div>
                        </div>
                        <Link to={"/kapelle/mitglieder"}>
                            <button>Unsere Mitglieder</button>
                        </Link>
                    </motion.div>
                </div>
                <div className="history">
                    <HorizontalScroll
                        items={geschichte}
                        isLoading={isLoading}
                    />
                </div>
                <div className="grid" id="vorstand">
                    <motion.div
                        className="right"
                        initial={{ opacity: 0, y: 200 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5, ease: "easeOut" }}
                    >
                        <h2>Der Vorstand</h2>
                        <p>Gemäß der Vereinsstatuten der Musikkapelle St. Lorenzen wird der Vorstand durch die Vollversammlung der Kapelle für drei Jahre gewählt. Der Obmann führt den Vorsitz und ist gleichzeitig der gesetzliche Vertreter des Vereins. In musikalischer Hinsicht leitet der Kapellmeister die Kapelle.</p>
                        <Link to={"/kapelle/vorstand"}>
                            <button>Unser Vorstand</button>
                        </Link>
                    </motion.div>
                    <motion.img
                        src="https://mk-lorenzen.it/admin/wp-content/uploads/2025/03/20250120-MTN08704-scaled.jpg"
                        alt="Kapelle"
                        className="left"
                        initial={{ opacity: 0, y: 100 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5, ease: "easeOut" }}
                    />
                </div>
                <div className="grid" id="musikfahne">
                    <motion.img
                        src="https://mk-lorenzen.it/admin/wp-content/uploads/2025/03/20250322-MTN08854-scaled.jpg"
                        alt="Kapelle"
                        className="left"
                        initial={{ opacity: 0, y: 100 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5, ease: "easeOut" }}
                    />
                    <motion.div
                        className="right"
                        initial={{ opacity: 0, y: 200 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5, ease: "easeOut" }}
                    >
                        <h2>Die Musikfahne</h2>
                        <p>Seit ihrer Weihe am 5. September 1982 begleitet unsere Fahne die Musikkapelle als sichtbares Zeichen. Fahnenpatin ist Doris Holas Castlunger. Hubert Leitner führt als Fähnrich die Fahne bei unseren Ausrückungen an. Im Jahr 2025 wurde die Fahne restauriert, um sie auch in Zukunft in voller Pracht zu bewahren.</p>
                    </motion.div>
                </div>
            </div>
        </div>
    );
};

export default Kapelle;
